<template>
  <div>
    <router-view />
  </div>
</template>

<script>

  export default {
    name: 'BlankLayout',
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Layouts/BlankLayout.vue